/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import CheckArn from "./CheckArn.container";

export default CheckArn;
